import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { PagedPks } from '../../models/paged-pks.interface';
import { Pk } from '../../models/pk.model';
import { Api } from '../util/api';
import { SearchUtilsService } from '../util/search-utils.service';

@Injectable()
export class PksService {
  private endpoint: string = 'pks';

  constructor(private api: Api,
              private searchUtilsService: SearchUtilsService) {
  }

  getPkByLocation(pk: Pk): Observable<Pk> {
    const searchParams = {
      'line.id': pk.line.id,
      way: pk.way,
      potential: pk.potential,
      number: pk.number
    };
    const params = new HttpParams()
      .set('page', '0')
      .set('size', '1')
      .set('search', this.searchUtilsService.getSearchStringFromParams(searchParams));
    return this.api.get(`${this.endpoint}/search`, params).map(
      (pagedPks: PagedPks) => pagedPks.content[0]
    );
  }

  getPksByLocation(pk: Pk, startPkNumber?: number, endPkNumber?: number): Observable<PagedPks> {
    let size: number;
    if (endPkNumber && startPkNumber) {
      size = endPkNumber - startPkNumber + 1;
    } else {
      size = 10;
    }
    const searchParams = {
      'line.id': pk.line.id,
      way: pk.way,
      potential: pk.potential,
      startPkNumber: startPkNumber,
      endPkNumber: endPkNumber
    };
    const params = new HttpParams()
      .set('page', '0')
      .set('size', size.toString())
      .set('search', this.searchUtilsService.getSearchStringFromParams(searchParams));

    return this.api.get(`${this.endpoint}/search`, params);
  }

  savePks(pks: Pk[], withReplacement: boolean = false): Observable<any> {
    const pkSaveRequests = [];
    pks.forEach(pk => pkSaveRequests.push(this.savePk(pk, withReplacement)));
    return Observable.forkJoin(pkSaveRequests).map(
      (pks) => this.api.handleSuccess(pks)
    );
  }

  searchPks(searchParams, priorityType: string, page: number = 0, size: number = 10, meterToReplace: string): Observable<PagedPks> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (priorityType === 'replacement') {
      params = params.set('sort', 'earlyPredictedReplacementDate,latePredictedReplacementDate,asc');
    } else if (priorityType === 'alert-thickness') {
      params = params.set('sort', 'earlyPredictedComplementaryMeasures,latePredictedComplementaryMeasures,asc')
    }

    let search = this.searchUtilsService.getSearchStringFromParams(searchParams);
    if (search.length) {
      params = params.set('search', search);
    }

    if(meterToReplace != null){
      params = params.set('metersToReplace', meterToReplace.indexOf(".") == -1 ? meterToReplace : meterToReplace.substr(0, meterToReplace.indexOf(".")));
    }
    return this.api.get(`${this.endpoint}/search`, params);
  }

  private savePk(pk: Pk, withReplacement: boolean = false): Observable<Pk> {
    const params = new HttpParams()
      .set('withReplacement', withReplacement.toString());
    return this.api.put(`${this.endpoint}/${pk.id}`, pk, { params: params });
  }

  public downloadPkData(searchParams, meterToReplace: string): Observable<any> {
    const options = {
      responseType: 'text'
    };
    let params = new HttpParams()
      .set('search', this.searchUtilsService.getSearchStringFromParams(searchParams));

    if(meterToReplace != null){
      params = params.set('metersToReplace', meterToReplace.indexOf(".") == -1 ? meterToReplace : meterToReplace.substr(0, meterToReplace.indexOf(".")));
    }

    return this.api.get(`${this.endpoint}/download`, params, options).map(
      csvText => new Blob([csvText], { type: 'text/csv' })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data/pks.service.ts